'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _reduxActions = require('redux-actions');

var _VisitorActionTypes = require('../../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _buildMessageKey = require('conversations-schema/pubnub-message/operators/buildMessageKey');

var _ThreadHistory = require('conversations-schema/thread-history/ThreadHistory');

var _ThreadHistory2 = _interopRequireDefault(_ThreadHistory);

var _addPageOfMessagesToThreadHistory = require('conversations-schema/thread-history/operators/addPageOfMessagesToThreadHistory');

var _updateMessageInThreadHistory = require('conversations-schema/thread-history/operators/updateMessageInThreadHistory');

var _IndexedAsyncData = require('conversations-async-data/indexed-async-data/IndexedAsyncData');

var _IndexedAsyncData2 = _interopRequireDefault(_IndexedAsyncData);

var _updateEntry = require('conversations-async-data/indexed-async-data/operators/updateEntry');

var _setEntry = require('conversations-async-data/indexed-async-data/operators/setEntry');

var _AsyncData = require('conversations-async-data/async-data/AsyncData');

var _AsyncData2 = _interopRequireDefault(_AsyncData);

var _requestStarted = require('conversations-async-data/async-data/operators/requestStarted');

var _requestSucceededWithOperator = require('conversations-async-data/async-data/operators/requestSucceededWithOperator');

var _requestFailed = require('conversations-async-data/async-data/operators/requestFailed');

var _updateAsyncData = require('conversations-async-data/async-data/operators/updateAsyncData');

var _asyncStatuses = require('conversations-async-data/async-data/constants/asyncStatuses');

var _asyncActionTypes = require('../../pubsub/constants/asyncActionTypes');

var _ActionTypes = require('../constants/ActionTypes');

var _addMessageToThreadHistory = require('../operators/addMessageToThreadHistory');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = (0, _IndexedAsyncData2.default)({
  notSetValue: (0, _AsyncData2.default)({ data: new _ThreadHistory2.default() })
});

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _ActionTypes.FETCH_THREAD_HISTORY.STARTED, function (state, action) {
  var requestArgs = action.payload.requestArgs;


  return (0, _updateEntry.updateEntry)(requestArgs.threadId, _requestStarted.requestStarted, state);
}), _defineProperty(_handleActions, _ActionTypes.FETCH_THREAD_HISTORY.SUCCEEDED, function (state, action) {
  var _action$payload = action.payload,
      requestArgs = _action$payload.requestArgs,
      newHistoryPage = _action$payload.data.threadHistory;


  return (0, _updateEntry.updateEntry)(requestArgs.threadId, (0, _requestSucceededWithOperator.requestSucceededWithOperator)((0, _addPageOfMessagesToThreadHistory.addPageOfMessagesToThreadHistory)(newHistoryPage)), state);
}), _defineProperty(_handleActions, _ActionTypes.FETCH_THREAD_HISTORY.FAILED, function (state, action) {
  var requestArgs = action.payload.requestArgs;


  return (0, _updateEntry.updateEntry)(requestArgs.threadId, _requestFailed.requestFailed, state);
}), _defineProperty(_handleActions, ActionTypes.RECEIVED_INCOMING_MESSAGE, function (state, action) {
  var _action$payload2 = action.payload,
      message = _action$payload2.message,
      threadId = _action$payload2.threadId;


  var messageKey = (0, _buildMessageKey.buildMessageKey)(message);

  return (0, _updateEntry.updateEntry)(threadId, (0, _updateAsyncData.updateAsyncData)((0, _addMessageToThreadHistory.addMessageToThreadHistory)(messageKey, message)), state);
}), _defineProperty(_handleActions, _asyncActionTypes.PUBLISH_MESSAGE.SUCCEEDED, function (state, action) {
  var _action$payload3 = action.payload,
      publishedMessage = _action$payload3.publishedMessage,
      threadId = _action$payload3.threadId;


  var messageKey = (0, _buildMessageKey.buildMessageKey)(publishedMessage);

  return (0, _updateEntry.updateEntry)(threadId, (0, _updateAsyncData.updateAsyncData)((0, _addMessageToThreadHistory.addMessageToThreadHistory)(messageKey, publishedMessage)), state);
}), _defineProperty(_handleActions, ActionTypes.UPDATE_MESSAGE_IN_CONVERSATION, function (state, action) {
  var _action$payload4 = action.payload,
      message = _action$payload4.message,
      threadId = _action$payload4.threadId,
      updated = _action$payload4.updated;


  var messageKey = (0, _buildMessageKey.buildMessageKey)(message);

  return (0, _updateEntry.updateEntry)(threadId, (0, _updateAsyncData.updateAsyncData)((0, _updateMessageInThreadHistory.updateMessageInThreadHistory)(messageKey, updated)), state);
}), _defineProperty(_handleActions, ActionTypes.CREATE_VISITOR_THREAD_SUCCESS, function (state, action) {
  var threadId = (0, _getIn2.default)(['payload', 'threadId'], action);
  return (0, _setEntry.setEntry)(threadId, new _AsyncData2.default({ data: new _ThreadHistory2.default(), status: _asyncStatuses.SUCCEEDED }), state);
}), _handleActions), initialState);
module.exports = exports['default'];